import { render, staticRenderFns } from "./availableTeacher.vue?vue&type=template&id=def5604e&"
import script from "./availableTeacher.vue?vue&type=script&lang=js&"
export * from "./availableTeacher.vue?vue&type=script&lang=js&"
import style0 from "./availableTeacher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports